module.exports = __webpack_public_path__ + "static/media/gal-6.aa2376b5.jpeg";